"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
// Getting Site Section with browser default props
var getSiteSection = function () {
    var locationPathname = (0, utils_1.removeSpecialCharacters)(window.location.pathname);
    if (locationPathname.split("/")[1] === "") {
        return "home";
    }
    return locationPathname.split("/")[1].replace(".", "-").toLowerCase();
};
exports.default = getSiteSection;
